<template>
    <div class="form-input-container">
        <div class="form-title"><label for="id">{{translate(label)}} <span class="required"
                    v-if="required">*</span></label></div>
        <textarea class="form-textarea"  v-model="model" :style="'height:' + height + 'px'"></textarea>
    </div>
</template>
<script>
    export default {
        props: {
            value: {}, label:{}, 
            height: {
                type: String,
                default: 38
            },
            required: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                localValue: this.value
            }
        },
        created() {
            this.setFieldValue()
        },
        methods: {
            setFieldValue() {
                this.localValue = this.model
            },
        },
        watch: {
            model() {
                this.setFieldValue()
            },
            localValue(val) {
                this.$emit('input', val)
            },
            value(val) {
                this.localValue = val
            }
        },
        computed: {
            model: {
                get() {
                    return this.localValue
                },
                set(value) {
                    if (value.constructor.name.toLowerCase() !== 'inputevent') {
                        this.$nextTick(() => {
                            this.localValue = value
                        })
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .form-input-container {
        margin-bottom: 12px;
    }

    .form-title {
        margin-bottom: 8px;
    }

    .form-textarea {
        width: 100%;
        height: 38px;
        font-size: 14px;
        padding: 4px 12px;
        border: 2px solid #EEE;
        border-radius: 6px;
        font-family: "Open Sans", "Hanuman", sans-serif;
        resize: vertical;
    }

    .form-textarea:focus {
        border: 2px solid #353690;
    }
</style>


// WEBPACK FOOTER //
// src/components/Forms/Textarea.vue